export const AnalyticsSchemas = {
  webDeviceControl: "web_device_control",
  webScheduleEvent: "web_schedule_event",
  csvReportDownload: "csv_report_download",
  webAuditTrailDownload: "web_audit_trail_download",
  webSearch: "web_search",
  webUserManagement: "web_user_management",
};

export const ControlType = {
  temperatureChange: "temperature_change",
  modeChange: "mode_change",
  fanSpeedChange: "fan_speed_change",
  powerStateChange: "power_state_change",
  currentLimitChange: "current_limit_change",
  controlValuesToggle: "control_values_toggle",
  setpointLimitChange: "setpoint_limit_change",
  forceReset: "force_reset",
};

export const ScheduleAction = {
  create: "create",
  update: "update",
  delete: "delete",
  deleteAll: "delete_all",
  globalEnable: "global_enable",
  globalDisable: "global_disable",
};

export const ReportKind = {
  alerts: "ALERTS",
  data: "DATA",
};

export const ReportScope = {
  zone: "zone",
  unit: "unit",
};

export const SearchContext = {
  units: "units",
  reportUnits: "report_units",
  alerts: "alerts",
  manageUnits: "manage_units",
  zones: "zones",
  userManagement: "user_management",
  allowedSerialNumbers: "allowed_serial_numbers",
};

export const UserManagementAction = {
  create: "create",
  delete: "delete",
};

export const UserManagementScope = {
  selfService: "self_service",
  gradientAdmin: "gradient_admin",
};
